import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { isEmpty } from 'lodash';
import cartImg from 'src/assets/card-image.png';
import Icon from 'src/components/common/Icon';
import { useAppSelector } from 'src/hooks/store';
import { selectParties } from 'src/store/data/selectors';
import { Party } from 'src/types/data-types';
import { clientSession } from 'src/utils/session-storage';

import css from './Questions.module.scss';

export default function ComparisonSection() {
  const parties = useAppSelector(selectParties);
  const [partyAData, setPartyAData] = useState<Party | null>(null);
  const [partyBData, setPartyBData] = useState<Party | null>(null);

  useEffect(() => {
    const session = clientSession.get();
    if (session?.partyAId && session.partyBId && !isEmpty(parties)) {
      const partyAData = parties.find((party: Party) => party.id === session?.partyAId);
      const partyBData = parties.find((party: Party) => party.id === session?.partyBId);

      if (partyAData) setPartyAData(partyAData);
      if (partyBData) setPartyBData(partyBData);
    }
  }, [parties]);

  return (
    <div className={css.comparison}>
      <div className={cn(css.party, css.blue)}>
        <img src={partyAData?.leaderImageUrl} alt={partyAData?.id} />
        <div className={css.label}>{partyAData?.name}</div>
      </div>
      <Icon type="vs" className={css.vsIcon} />
      <div className={cn(css.party, css.red)}>
        <img src={partyBData?.leaderImageUrl} alt={partyBData?.leaderName} />
        <div className={css.label}>{partyBData?.name}</div>
      </div>
    </div>
  );
}
